import React, { useContext, useEffect } from "react";

import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { ErrorMessage } from "@hookform/error-message";
import { errorMessage } from "utils/utilities";
import { AutoGrowTextarea } from "components/AutoGrowTextarea";
import NotyfContext from "contexts/NotyfContext";

import * as fsrsApi from "@api/fsrsApi";

export const StarRateModal = ({
    modalInfo,
    setModalInfo,
    rerender,
    setRerender,
}) => {
    const notyf = useContext(NotyfContext);

    //
    // States
    //

    const schema = yup.object().shape({
        rate: yup.string().required("This field is required"),
        unit: yup.string().required("This field is required"),
    });

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    //
    // Functions
    //

    const closeModal = () => {
        reset({ rate: "" });
        setRerender(!rerender);
        setModalInfo({ open: false });
    };

    const starRateApi = async (data) => {
        try {
            const response = await fsrsApi.createStarRate(data);

            // const response = modalInfo.edit
            //     ? await fsrsApi.updateStarRate(data)
            //     : await fsrsApi.createStarRate(data);

            if (response.status === 201 || response.status === 200) {
                notyf.open({
                    type: "success",
                    message: `Successfully ${
                        modalInfo.edit ? "updated" : "created"
                    } star rate`,
                });
            }
            closeModal();
        } catch (error) {
            notyf.open({
                type: "danger",
                message: "Something went wrong with the server",
            });
        }
    };

    useEffect(() => {
        if (modalInfo?.item && Object.keys(modalInfo?.item).length) {
            reset({
                rate: modalInfo.item.rate,
                unit: modalInfo.item.unit,
                category: modalInfo.item.category,
                item_description: modalInfo.item.item_description,
            });
        }
        // eslint-disable-next-line
    }, [modalInfo]);

    return (
        <Modal
            show={modalInfo.open}
            onHide={() => closeModal()}
            size="lg"
            centered
        >
            <Modal.Header closeButton>Star rate item</Modal.Header>
            <Modal.Body className="m-1">
                <Container fluid className="p-0">
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="description">
                                    Rate (S$)
                                </Form.Label>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="rate"
                                    render={({
                                        field: { value, onChange, onBlur },
                                    }) => (
                                        <Form.Control
                                            className={`form-box ${
                                                errors.rate && "is-invalid"
                                            }`}
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            type="number"
                                            min="1"
                                            value={value}
                                        />
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="rate"
                                    render={({ message }) =>
                                        errorMessage(message)
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="description">
                                    Unit
                                </Form.Label>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="unit"
                                    render={({
                                        field: { value, onChange, onBlur },
                                    }) => (
                                        <Form.Control
                                            className={`form-box ${
                                                errors.unit && "is-invalid"
                                            }`}
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            type="text"
                                            value={value}
                                        />
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="unit"
                                    render={({ message }) =>
                                        errorMessage(message)
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="mark_up">
                                    Category
                                </Form.Label>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="category"
                                    render={({
                                        field: { value, onChange, onBlur },
                                    }) => (
                                        <Form.Control
                                            className={`form-box ${
                                                errors.category && "is-invalid"
                                            }`}
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            type="text"
                                            value={value}
                                        />
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="category"
                                    render={({ message }) =>
                                        errorMessage(message)
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="item_description">
                                    Description
                                </Form.Label>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="item_description"
                                    render={({
                                        field: { value, onChange, onBlur },
                                    }) => (
                                        <AutoGrowTextarea
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            fieldValue={value}
                                            errors={errors.item_description}
                                        />
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="item_description"
                                    render={({ message }) =>
                                        errorMessage(message)
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col md={12} className="text-center">
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit(starRateApi)}
                        >
                            Submit
                        </Button>
                        <Button variant="link" onClick={() => closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};
